export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Shop-Gray-7a90213385616a1678ef0c3648b0161d.svg";